import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { PreOrderMessageUI } from "./PreOrderMessageUI";
import { getColourGroupForVariant } from "../../utils/product/getColourGroupForVariant";

export const PreOrderMessage = ({
  product,
}: Pick<StandardProps, "product">) => {
  const { variant, isSelected } = useVariant(product);

  const availability = isSelected
    ? variant.availability
    : getColourGroupForVariant(product.variantGroups, variant.id)?.availability;

  const messages = buildMessages(availability);

  return <PreOrderMessageUI messages={messages} />;
};

function buildMessages(availability: PreOrderAvailability): string[] {
  const messages: string[] = [];

  const comingSoonMessage =
    availability?.futureAvailability?.availableToOrderFromMessage;
  const preOrderMessage = availability?.preOrder?.streetDateMessage;

  if (comingSoonMessage) {
    messages.push(comingSoonMessage);
  }
  if (preOrderMessage) {
    messages.push(preOrderMessage);
  }
  return messages;
}

type PreOrderAvailability =
  | {
      futureAvailability?: {
        availableToOrderFromMessage?: string | null;
      } | null;
      preOrder?: {
        streetDateMessage?: string | null;
      } | null;
    }
  | undefined
  | null;
